import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_ENTITIES_OFFICE_LIST = graphql(`
  query GetOfficeList(
    $filters: EntityFilterInput!
    $sort: PaginationSort
    $pagination: PaginationRequest
  ) {
    entities(sort: $sort, pagination: $pagination, filters: $filters) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          offices(pagination: { first: 10000 }) {
            edges {
              node {
                name
                uuid
                address {
                  street1
                }
                persons {
                  edges {
                    node {
                      firstName
                    }
                  }
                }
                users {
                  edges {
                    cursor
                    node {
                      uuid
                      username
                      userId
                      groups
                      type
                    }
                  }
                }
              }
            }
          }
          teams(pagination: $pagination) {
            edges {
              node {
                name
                description
                uuid
                users {
                  edges {
                    cursor
                    node {
                      uuid
                      username
                      userId
                      groups
                      type
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`);
export function useGetOfficeList({
  brokerageUuid,
  enabled,
}: {
  brokerageUuid: string;
  enabled: boolean;
}) {
  const { loading, error, data } = useQuery(GET_ENTITIES_OFFICE_LIST, {
    variables: {
      pagination: { first: 100000 },
      filters: { entityUuid: brokerageUuid },
    },
    skip: !enabled,
  });

  return {
    error,
    loading,
    data,
  };
}
